<script setup>
import ReviewQueueComponent from "@/Components/ReviewQueue/ReviewQueueComponent.vue";
import ClaimCreatorComponent from "@/Components/Claims/ClaimCreatorComponent.vue";
import MessagesComponent from "@/Components/Messaging/MessagesComponent.vue";
import TasksPendingComponent from "@/Components/TasksPending/TasksPendingComponent.vue";
import TasksPendingExpired from "@/Components/TasksPending/TasksPendingExpired.vue";
import UnassignedClaimsComponent from "@/Components/Claims/UnassignedClaimsComponent.vue";
import TasksPendingAdjuster from "@/Components/TasksPending/TasksPendingAdjuster.vue";
import {Permissions} from "@/Utils/Permissions";
import ClientSelectComponent from "@/Components/Clients/ClientSelectComponent.vue";
import {reactive} from "vue";

const data = reactive({
  clientId: null
});

</script>

<template>
  <v-container fluid>
    <v-row>
      <v-col cols="3" v-if="Permissions.checkPermissions(['review-queue.get'])">
        <ReviewQueueComponent/>
      </v-col>
      <v-col cols="3" v-if="Permissions.checkPermissions(['claims.create'])">
        <ClaimCreatorComponent contextSchemaA="claims"/>
      </v-col>
      <v-col cols="3">
        <ClientSelectComponent @clientSelected="(id) => data.clientId = id"/>
      </v-col>
      <v-col cols="12" v-if="Permissions.checkPermissions(['messages.list'])">
        <MessagesComponent contextSchemaA="claims" :clientId="data.clientId"/>
      </v-col>
      <v-col cols="12" v-if="Permissions.checkPermissions(['tasks-pending.list'])">
        <TasksPendingComponent contextSchemaA="claims" :clientId="data.clientId"/>
      </v-col>
      <v-col cols="12" v-if="Permissions.checkPermissions(['tasks-pending.list-expired'])">
        <TasksPendingExpired contextSchemaA="claims" :clientId="data.clientId"/>
      </v-col>
      <v-col cols="12" v-if="Permissions.checkPermissions(['claims.unassigned'])">
        <UnassignedClaimsComponent :clientId="data.clientId"/>
      </v-col>
      <v-col cols="12" v-if="Permissions.checkPermissions(['tasks-pending.list-adjuster'])">
        <TasksPendingAdjuster :clientId="data.clientId"/>
      </v-col>
    </v-row>
  </v-container>
</template>